import React from 'react'
import './index.css'
import CloseIcon from '@mui/icons-material/Close';

const IconClose = (props) => (
    <div key={"close"} className='IconClose' onClick={props.edit} style={ props.justifyRight&& {display:"flex", justifySelf:"right"}} >
        <CloseIcon style={{height:"30px", width:"30px"}}  alt="delete.svg" />
    </div>
)

export default IconClose